export const corePageMessages = {
  loadingPage: 'Loading page',
  renderErrorTitle: 'The Admin could not finish loading',
  renderErrorDescription: 'Reload the page to request a fresh copy of the Admin application.',
  reloadPage: 'Reload page',
  closeDialog: 'Close dialog',
  back: 'Go back',
  confirm: 'Confirm',
  dismissNotification: 'Dismiss notification',
  navigationMenu: 'Navigation menu',
  copyShortLinkAria: 'Copy /{slug}',
  openShortLinkAria: 'Open /{slug} in a new tab',
  dashboardSubtitle: 'Your Linketry dashboard',
  totalLinks: 'Total Links',
  totalClicks: 'Total Clicks',
  todayClicks: "Today's Clicks",
  recentlyCreated: 'Recently Created',
  topLinks: 'Top Links by Clicks',
  viewAll: 'View all →',
  noLinksYet: 'No links yet.',
  createOne: 'Create one →',
  noClicksYet: 'No clicks recorded yet.',
  overviewEmptyTitle: 'Get started with Linketry',
  overviewEmptyHint:
    'Create your first short link, or open Setup to finish the first-run checklist.',
  clicksCount: '{count} clicks',
  copiedClipboard: 'Copied to clipboard',
  overviewLoadFailed: 'Failed to load overview stats',
  addShortLink: 'Add a new short link',
  destinationUrl: 'Destination URL *',
  destinationHint: 'The URL this short link will redirect to',
  duplicateDestinationWarning:
    'This destination is already used by {count} link(s). You can still save an intentional duplicate.',
  duplicateDestinationMore: 'More matching links exist; only the first five are shown.',
  destinationRequired: 'Destination URL is required',
  invalidHttpUrl: 'URL must start with http:// or https://',
  customSlug: 'Custom Slug (optional)',
  customSlugHint: 'Leave blank to auto-generate. Letters, numbers, - and _ only.',
  invalidSlug: 'Slug can only contain letters, numbers, _ and -',
  reservedSlug: 'This slug is a reserved path and cannot be used',
  slugTooLong: 'Slug cannot exceed 100 characters',
  invalidDomain: 'Enter a valid domain, without a path or protocol',
  titleOptional: 'Title (optional)',
  fetchTitle: 'Fetch Title',
  titleFetched: 'Title fetched',
  tagsOptional: 'Tags (optional)',
  tagsPlaceholder: 'marketing, campaign, product',
  tagsHint: 'Comma-separated tags. Existing catalog tags are available below.',
  redirectTypeLabel: 'Redirect Type',
  redirect302: '302 — Temporary (recommended)',
  redirect301: '301 — Permanent (cached by browser)',
  cancel: 'Cancel',
  linkCreated: 'Link /{slug} created!',
  descriptionTooLong: 'Description must be 240 characters or less',
  invalidDateTime: 'Enter a valid date and time',
  invalidMaxClicks: 'Max clicks must be a positive integer',
  shortPassword: 'Password must be at least 8 characters',
  linksCount: '{count} links',
  searchLinks: 'Search slug, URL, title…',
  statusFilter: 'Filter by status',
  sortLinks: 'Sort links',
  createdFrom: 'Created from',
  createdTo: 'Created to',
  allStatus: 'All Status',
  activeStatus: 'Active',
  disabledStatus: 'Disabled',
  expiredStatus: 'Expired',
  archivedStatus: 'Archived',
  newestFirst: 'Newest First',
  oldestFirst: 'Oldest First',
  mostClicks: 'Most Clicks',
  recentlyClicked: 'Recently Clicked',
  leastRecentlyClicked: 'Least Recently Clicked',
  recentlyUpdated: 'Recently Updated',
  oldestUpdated: 'Oldest Updated',
  linksLoadFailed: 'Failed to load links',
  copied: 'Copied!',
  copyFailed: 'Could not copy to the clipboard',
  qrFailed: 'Failed to generate QR code',
  qrModuleUnavailable: 'Could not load the QR generator. Reload the page and try again.',
  qrDownloaded: 'QR code downloaded',
  linkDeleted: 'Link deleted',
  linkDisabled: 'Link disabled',
  linkEnabled: 'Link enabled',
  linkArchived: 'Link archived',
  linkRestored: 'Link restored',
  noLinksFound: 'No links found',
  createFirstLink: 'Create your first link',
  shortLink: 'Short Link',
  destination: 'Destination',
  clicks: 'Clicks',
  status: 'Status',
  created: 'Created',
  actions: 'Actions',
  copy: 'Copy',
  open: 'Open',
  qrCode: 'QR Code',
  edit: 'Edit',
  disable: 'Disable',
  enable: 'Enable',
  archive: 'Archive',
  restore: 'Restore',
  delete: 'Delete',
  deleteLink: 'Delete Link',
  disableLink: 'Disable Link',
  archiveLink: 'Archive Link',
  deleteLinkConfirm: 'Permanently delete "/{slug}"? This cannot be undone.',
  disableLinkConfirm: 'Disable "/{slug}"? The short link will stop working.',
  archiveLinkConfirm: 'Archive "/{slug}"?',
  pageOf: 'Page {page} of {total}',
  previous: 'Prev',
  next: 'Next',
  copyLink: 'Copy Link',
  downloadPng: 'Download PNG',
  passwordProtected: 'Password protected',
  safetyWarningEnabled: 'Safety warning enabled',
  selectAllVisibleLinks: 'Select all visible links',
  selectLinkAria: 'Select /{slug}',
  qrCodeFor: 'QR code for {url}',
  qrCodeTitle: 'QR Code /{slug}',
  downloadSvg: 'Download SVG',
  qrStyle: 'Style',
  qrForeground: 'Code colour',
  qrBackground: 'Background',
  qrLogo: 'Centre logo',
  qrLogoUpload: 'Upload logo',
  qrLogoReplace: 'Replace logo',
  qrLogoRemove: 'Remove',
  qrLogoPreview: 'Current logo',
  qrLogoHint: 'PNG, JPEG, WebP or SVG. Stored as a PNG of at most 256 px.',
  qrLogoTooLarge: 'This logo is still over 48 kB after downscaling. Use a simpler image.',
  qrLogoUnreadable: 'This file could not be read as an image.',
  qrCaption: 'Show the short URL under the code',
  qrSize: 'Size',
  qrFormat: 'Format',
  qrResetStyle: 'Reset to standard',
  qrSaveDefault: 'Save as default',
  qrStyleSaved: 'Default QR style saved',
  qrStyleSaveFailed: 'Could not save the default QR style',
  qrRendering: 'Rendering…',
  qrPreviewHidden: 'Fix the colours to see a preview.',
  qrColorInverted: 'The code colour must be darker than the background, or many scanners will fail.',
  qrColorLowContrast: 'Contrast is below 4.5:1. Pick a darker code colour or a lighter background.',
  qrColorInvalid: 'Colours must be six-digit hex values.',
  qrScanChecking: 'Checking that the code scans…',
  qrScanPassed: 'Scan check passed.',
  qrScanFailed: 'This design does not scan reliably. Adjust the colours or remove the logo.',
  qrScanUnavailable: 'Scan check unavailable. Test the code with a phone before printing.',
} as const;
